import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { API_URL } from '../../../apiConfig';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import sanitizeHtml from 'sanitize-html';
import star from "../../../image/shines.png";

const AssessmentDetailsPage = () => {
  const { id } = useParams();
  const [assessmentMode, setAssessmentMode] = useState(0); // Default to 0 (Check Ans)
  const navigate = useNavigate();
  const [copied, setCopied] = useState(false);
  const [resultMode, setResultMode] = useState(0); 
  const [assessmentData, setAssessmentData] = useState({
     title: '',
     description: '',
     instructions: '',
     duration: 0,
     maxTries: 1,
     status: 0, // Default to draft
     slug: '', // Default to empty string
    assessmentMode: 0,
    jobDescription:  '',
        assessmentType:  '',
        difficultyLevel: '',
        numberOfQuestions :'10',
        isAiGenerated : 0,
  });
  const [isEditing, setIsEditing] = useState(false);
  const [difficultyOptions, setDifficultyOptions] = useState([]);
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    instructions: '',
    hours: '',
    minutes: '',
     maxTries: '1',
       assessmentMode: 0,
       jobDescription:  '',
        assessmentType:  '',
        difficultyLevel: '',
        numberOfQuestions :'10',
        isAiGenerated : 0,
  });
  const [adminData, setAdminData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isAddingQuestion, setIsAddingQuestion] = useState(false);
  const [questionType, setQuestionType] = useState(null);
  const [questionForm, setQuestionForm] = useState({
    title: '',
    options: ['', ''],
    reasons: ['', ''], // Initialize reasons array
    correctAnswers: [],
  });
  const [questions, setQuestions] = useState([]);
  const [editingQuestion, setEditingQuestion] = useState(null);

  // Load adminData from sessionStorage on mount
  useEffect(() => {
    const storedAdminData = JSON.parse(sessionStorage.getItem('adminData'));
    setAdminData(storedAdminData);
  }, []);

//   const handleToggleStatus = async () => {
//   try {
//     if (!adminData?.id) throw new Error('Admin not authenticated. Please log in.');

//     const newStatus = assessmentData.status === 0 ? 1 : 0; // Toggle between 0 (draft) and 1 (published)
//     const updateData = {
//       creatorId: adminData.id,
//       status: newStatus,
//     };

//     const response = await fetch(`${API_URL}/api/v1/admin/assessments/${id}`, {
//       method: 'PATCH',
//       headers: { 'Content-Type': 'application/json' },
//       credentials: 'include',
//       body: JSON.stringify(updateData),
//     });

//     if (!response.ok) {
//       const errorData = await response.json();
//       throw new Error(errorData.message || `Failed to ${newStatus === 1 ? 'post' : 'set to draft'} assessment`);
//     }

//     const result = await response.json();
//     setAssessmentData((prev) => ({
//       ...prev,
//       status: result.assessment.status,
//       slug: result.assessment.slug,
//     }));
//     setError(null);
//     alert(`Assessment ${newStatus === 1 ? 'posted' : 'set to draft'} successfully!`);
//   } catch (err) {
//     setError(err.message);
//   }
// };

 // Update fetchAssessment in useEffect to handle status and slug robustly

 const handleCopyLink = () => {
    const url = `${window.location.origin}/assessments/${assessmentData.slug}`;
    navigator.clipboard.writeText(url).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // Reset after 2 seconds
    });
  };
useEffect(() => {
   const fetchAssessment = async () => {
    try {
      const response = await fetch(`${API_URL}/api/v1/admin/assessments/${id}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
      });
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to fetch assessment');
      }
      const result = await response.json();
      const assessment = result.assessment;
      console.log('Fetched assessment:', assessment);
      const hours = Math.floor(assessment.duration / 60);
      const minutes = assessment.duration % 60;
      const status = assessment.status === 'published' ? 1 : assessment.status === 'draft' ? 0 : assessment.status;
      const mode = assessment.assessmentMode === 1 ? 1 : 0; // Ensure 0 or 1
      const resultMode = assessment.resultMode === 1 ? 1 : 0; // Ensure 0 or 1
      setAssessmentData({
        title: assessment.title || '',
        description: assessment.description || '',
        instructions: assessment.instructions || '',
        duration: assessment.duration || 0,
        maxTries: assessment.maxTries || 1,
        status: status || 0,
        slug: assessment.slug || '',
        jobDescription: assessment.jobDescription|| '',
        assessmentType: assessment.assessmentType|| '',
        difficultyLevel: assessment.difficultyLevel|| '',
        numberOfQuestions : assessment.numberOfQuestions|| 10,
        isAiGenerated : assessment.isAiGenerated|| 0,
        assessmentMode: mode,
       resultMode: assessment.resultMode || 0,
      });
      setFormData({
        title: assessment.title || '',
        description: assessment.description || '',
        instructions: assessment.instructions || '',
        jobDescription: assessment.jobDescription|| '',
        assessmentType: assessment.assessmentType|| '',
        difficultyLevel: assessment.difficultyLevel|| '',
        numberOfQuestions : assessment.numberOfQuestions|| 10,
        isAiGenerated : assessment.isAiGenerated|| 0,
        hours: hours.toString(),
        minutes: minutes.toString(),
        maxTries: (assessment.maxTries || 1).toString(),
        assessmentMode: mode,
      resultMode: assessment.resultMode || 0,
      });
      setAssessmentMode(mode);
      setResultMode(resultMode);

    } catch (err) {
      setError(err.message);
      console.error('Fetch assessment error:', err);
    }
  };


  const fetchData = async () => {
    await Promise.all([fetchAssessment(), fetchQuestions()]);
    setLoading(false);
  };

  fetchData();
}, [id]);
useEffect(() => {
  fetch(`${API_URL}/api/v1/difficultlevel`)
    .then((res) => res.json())
    .then((data) => setDifficultyOptions(data))
    .catch((err) => console.error('Error fetching difficulty levels:', err));
}, []);


// Update handleToggleStatus to handle backend response robustly
const handleToggleStatus = async () => {
  try {
    if (!adminData?.id) throw new Error('Admin not authenticated. Please log in.');

    const newStatus = assessmentData.status === 0 ? 1 : 0;
    const updateData = {
      creatorId: adminData.id,
      status: newStatus,
    };

    console.log('Sending toggle status request:', updateData); // Debug log
    const response = await fetch(`${API_URL}/api/v1/admin/assessments/${id}`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(updateData),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || `Failed to ${newStatus === 1 ? 'post' : 'set to draft'} assessment`);
    }

    const result = await response.json();
    console.log('Toggle status response:', result); // Debug log
    // Map string status to number if necessary
    const status = result.assessment.status === 'published' ? 1 : result.assessment.status === 'draft' ? 0 : result.assessment.status;
    setAssessmentData((prev) => ({
      ...prev,
      status: status || 0,
      slug: result.assessment.slug || '',
    }));
    setError(null);
    alert(`Assessment ${newStatus === 1 ? 'posted' : 'set to draft'} successfully!`);
  } catch (err) {
    setError(err.message);
    console.error('Toggle status error:', err);
  }
};
const handleToggleMode = async (newMode) => {
  try {
    if (!adminData?.id) throw new Error('Admin not authenticated. Please log in.');

    const modeValue = newMode === 'test' ? 1 : 0;
    const updateData = {
      creatorId: adminData.id,
      assessmentMode: modeValue,
    };

    console.log('Sending toggle mode request:', updateData);
    const response = await fetch(`${API_URL}/api/v1/admin/assessments/${id}`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(updateData),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to update assessment mode');
    }

    const result = await response.json();
    console.log('Toggle mode response:', result);
    setAssessmentData((prev) => ({
      ...prev,
      assessmentMode: result.assessment.assessmentMode,
    }));
    setFormData((prev) => ({
      ...prev,
      assessmentMode: result.assessment.assessmentMode,
    }));
    setAssessmentMode(result.assessment.assessmentMode);
    setError(null);
  } catch (err) {
    setError(err.message);
    console.error('Toggle mode error:', err);
  }
};
const handleToggleResult = async (newMode) => {
    try {
      if (!adminData?.id) throw new Error('Admin not authenticated. Please log in.');

      const modeValue = newMode === 'show' ? 1 : 0;
      const updateData = {
        creatorId: adminData.id,
        resultMode: modeValue,
      };

      console.log('Sending toggle result request:', updateData);
      const response = await fetch(`${API_URL}/api/v1/admin/assessments/${id}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(updateData),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to update result mode');
      }

      const result = await response.json();
      console.log('Toggle result response:', result);
      setResultMode(result.assessment.resultMode);
      setError(null);
    } catch (err) {
      setError(err.message);
      console.error('Toggle result error:', err);
    }
  };

  // Sanitize HTML for display and validation
  const sanitizeDescription = (html) => {
    const sanitized = sanitizeHtml(html, {
      allowedTags: ['p', 'b', 'i', 'u', 's', 'a', 'ul', 'ol', 'li', 'h1', 'h2', 'h3', 'blockquote', 'table', 'tr', 'td', 'th', 'strong', 'em'],
      allowedAttributes: {
        a: ['href'],
        table: ['border'],
        td: ['colspan', 'rowspan'],
        th: ['colspan', 'rowspan'],
      },
    });
    console.log('Sanitized description:', sanitized);
    return sanitized;
  };

  // Render sanitized HTML
  const renderHTML = (html) => {
    const sanitizedHTML = sanitizeDescription(html);
    return { __html: sanitizedHTML };
  };

  // Format duration into hours and minutes
  const formatDuration = (minutes) => {
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return `${hours > 0 ? `${hours}h ` : ''}${mins}m`;
  };

  // Handle input changes for editable fields
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setError(null);
  };

  // Handle CKEditor description changes
  const handleDescriptionChange = (event, editor) => {
    const data = editor.getData();
    console.log('CKEditor data:', data);
    setFormData((prev) => ({ ...prev, description: data }));
    setError(null);
  };
  // Add handleInstructionsChange for CKEditor
const handleInstructionsChange = (event, editor) => {
  const data = editor.getData();
  console.log('CKEditor instructions data:', data);
  setFormData((prev) => ({ ...prev, instructions: data }));
  setError(null);
};
// Handle CKEditor job description changes
const handleJobDescriptionChange = (event, editor) => {
  const data = editor.getData();
  console.log('CKEditor job description data:', data);
  setFormData((prev) => ({ ...prev, jobDescription: data }));
  setError(null);
};

// Handle difficulty level checkbox changes
const handleDifficultyChange = (value) => {
  setFormData((prev) => ({
    ...prev,
    difficultyLevel: prev.difficultyLevel === value ? '' : value, // Toggle selection
  }));
  setError(null);
};

  // Toggle edit mode for all fields
  const toggleEdit = () => {
  if (isEditing) {
    const hours = Math.floor(assessmentData.duration / 60);
    const minutes = assessmentData.duration % 60;
    setFormData({
      title: assessmentData.title,
      description: assessmentData.description,
      instructions: assessmentData.instructions,
      hours: hours.toString(),
      minutes: minutes.toString(),
      maxTries: assessmentData.maxTries.toString(),
      assessmentMode: assessmentData.assessmentMode,
    });
    setAssessmentMode(assessmentData.assessmentMode);
    setError(null);
  }
  setIsEditing(!isEditing);
};

const handleSave = async () => {
  try {
    if (!adminData?.id) throw new Error('Admin not authenticated. Please log in.');

    // Validate required fields
    if (!formData.title.trim()) throw new Error('Title cannot be empty.');
    if (!formData.description.trim()) throw new Error('Description cannot be empty.');
    if (!formData.instructions.trim()) throw new Error('Instructions cannot be empty.');
    const sanitizedDescription = sanitizeDescription(formData.description);
    const sanitizedInstructions = sanitizeDescription(formData.instructions);
    if (!sanitizedDescription.trim()) {
      throw new Error('Description contains only unsupported HTML tags or attributes. Please revise.');
    }
    if (!sanitizedInstructions.trim()) {
      throw new Error('Instructions contain only unsupported HTML tags or attributes. Please revise.');
    }
    const duration = parseInt(formData.hours || '0') * 60 + parseInt(formData.minutes || '0');
    if (duration <= 0) throw new Error('Duration must be greater than 0 minutes.');
    const maxTries = parseInt(formData.maxTries);
    if (!maxTries || maxTries < 1) throw new Error('Maximum tries must be at least 1.');
    if (![0, 1].includes(formData.assessmentMode)) {
      throw new Error('Invalid assessment mode.');
    }
    // Validate optional numberOfQuestions if provided
    const numberOfQuestions = parseInt(formData.numberOfQuestions.toString());
    if (formData.numberOfQuestions && (!numberOfQuestions || numberOfQuestions < 1)) {
      throw new Error('Number of questions must be at least 1.');
    }

    const updateData = {
      creatorId: adminData.id,
      title: formData.title,
      description: formData.description,
      instructions: formData.instructions,
      jobDescription: formData.jobDescription || '',
      assessmentType: formData.assessmentType || '',
      difficultyLevel: formData.difficultyLevel || '',
      numberOfQuestions: numberOfQuestions || 10,
      isAiGenerated: formData.isAiGenerated || 0,
      duration,
      maxTries,
      assessmentMode: formData.assessmentMode,
    };

    const response = await fetch(`${API_URL}/api/v1/admin/assessments/${id}`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(updateData),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to update assessment');
    }

    const result = await response.json();
    const updatedAssessment = result.assessment;
    setAssessmentData({
      title: updatedAssessment.title || '',
      description: updatedAssessment.description || '',
      instructions: updatedAssessment.instructions || '',
      jobDescription: updatedAssessment.jobDescription || '',
      assessmentType: updatedAssessment.assessmentType || '',
      difficultyLevel: updatedAssessment.difficultyLevel || '',
      numberOfQuestions: updatedAssessment.numberOfQuestions || 10,
      isAiGenerated: updatedAssessment.isAiGenerated || 0,
      duration: updatedAssessment.duration || 0,
      maxTries: updatedAssessment.maxTries || 1,
      status: updatedAssessment.status === 'published' ? 1 : updatedAssessment.status === 'draft' ? 0 : updatedAssessment.status,
      slug: updatedAssessment.slug || '',
      assessmentMode: updatedAssessment.assessmentMode || 0,
    });
    setAssessmentMode(updatedAssessment.assessmentMode || 0);
    setIsEditing(false);
    setError(null);
  } catch (err) {
    setError(err.message);
    console.error('Save error:', err);
  }
};

  // Open edit mode for a question
  const openEditQuestion = (question) => {
    setEditingQuestion(question);
    setQuestionType(question.type);
    setQuestionForm({
      title: question.questionText,
      options: question.options,
      reasons: question.reasons || question.options.map(() => ''), // Fallback to empty strings
      correctAnswers: question.correctAnswers || [],
    });
  };

  // Handle question type selection
  const handleQuestionTypeSelect = (e) => {
    setQuestionType(e.target.value);
  };

  // Handle question form input changes
  const handleQuestionInputChange = (e, index = null) => {
    const { name, value } = e.target;
    if (name === 'title') {
      setQuestionForm((prev) => ({ ...prev, title: value }));
    } else if (name.startsWith('option')) {
      const newOptions = [...questionForm.options];
      newOptions[index] = value;
      setQuestionForm((prev) => ({ ...prev, options: newOptions }));
    } else if (name.startsWith('reason')) {
      const newReasons = [...questionForm.reasons];
      newReasons[index] = value;
      setQuestionForm((prev) => ({ ...prev, reasons: newReasons }));
    }
  };

  // Handle correct answer selection
  const handleCorrectAnswerChange = (e, index) => {
    const { checked, value } = e.target;
    if (questionType === 'single') {
      setQuestionForm((prev) => ({
        ...prev,
        correctAnswers: [parseInt(value)],
      }));
    } else {
      setQuestionForm((prev) => {
        const newCorrectAnswers = checked
          ? [...prev.correctAnswers, parseInt(value)]
          : prev.correctAnswers.filter((i) => i !== parseInt(value));
        return { ...prev, correctAnswers: newCorrectAnswers };
      });
    }
  };

  // Add a new option
  const addOption = () => {
    setQuestionForm((prev) => ({
      ...prev,
      options: [...prev.options, ''],
      reasons: [...prev.reasons, ''], // Add empty reason for new option
    }));
  };

  // Delete an option
  const deleteOption = (index) => {
    if (questionForm.options.length <= 2) return;
    setQuestionForm((prev) => {
      const newOptions = prev.options.filter((_, i) => i !== index);
      const newReasons = prev.reasons.filter((_, i) => i !== index);
      const newCorrectAnswers = prev.correctAnswers
        .filter((answerIndex) => answerIndex !== index)
        .map((answerIndex) => (answerIndex > index ? answerIndex - 1 : answerIndex));
      return {
        ...prev,
        options: newOptions,
        reasons: newReasons,
        correctAnswers: newCorrectAnswers,
      };
    });
  };

  
    const fetchQuestions = async () => {
      try {
        const response = await fetch(`${API_URL}/api/v1/admin/assessments/${id}/questions`, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
        });
        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.message || 'Failed to fetch questions');
        }
        const result = await response.json();
        console.log('Fetched questions:', result.questions); // Debug log
        setQuestions(Array.isArray(result.questions) ? result.questions : []);
      } catch (err) {
        setError(err.message);
        console.error('Fetch questions error:', err);
        setQuestions([]);
      }
    };

  const stripHTML = (html) => {
    const plainText = sanitizeHtml(html, {
      allowedTags: [], // Disallow all HTML tags
      allowedAttributes: {}, // Disallow all attributes
    });
    console.log('Stripped description:', plainText);
    return plainText;
  };

 const handleAddAIQuestion = async (id, formData) => {
  console.log("Original description:", formData.jobDescription);
      setLoading(true);
  try {
    const plainDescription = stripHTML(formData.jobDescription);

    const response = await fetch(`${API_URL}/api/v1/admin/assessments/${id}/apiquestion`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({
        description: plainDescription,
        assessmentType: formData.assessmentType,
        difficultyLevel: formData.difficultyLevel,
        numberOfQuestions: formData.numberOfQuestions,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log('API response:', data);
    await fetchQuestions();
    return data;
  } catch (error) {
    console.error('Error calling API:', error);
    throw error;
  }finally {
    setLoading(false); // stop loader
  }
};

  // Handle question form submission (add or edit)
  const handleQuestionSubmit = async () => {
    try {
      if (!adminData?.id) throw new Error('Admin not authenticated. Please log in.');

      const questionData = {
        questionText: questionForm.title,
        type: questionType,
        options: questionForm.options,
        reasons: questionForm.reasons, // Include reasons
        correctAnswers: questionForm.correctAnswers,
        creatorId: adminData.id,
        assessment: id,
      };

      const url = editingQuestion
        ? `${API_URL}/api/v1/admin/assessments/${id}/questions/${editingQuestion._id}`
        : `${API_URL}/api/v1/admin/assessments/${id}/questions`;
      const method = editingQuestion ? 'PATCH' : 'POST';

      const response = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(questionData),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `Failed to ${editingQuestion ? 'update' : 'add'} question`);
      }

      // Fetch updated questions list
      const questionsResponse = await fetch(`${API_URL}/api/v1/admin/assessments/${id}/questions`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
      });

      if (!questionsResponse.ok) {
        const errorData = await questionsResponse.json();
        throw new Error(errorData.message || 'Failed to fetch updated questions');
      }

      const questionsResult = await questionsResponse.json();
      setQuestions(questionsResult.questions);
      setIsAddingQuestion(false);
      setQuestionType(null);
      setQuestionForm({ title: '', options: ['', ''], reasons: ['', ''], correctAnswers: [] });
      setEditingQuestion(null);
      setError(null);
    } catch (err) {
      setError(err.message);
    }
  };

  // Cancel editing a question
  const cancelEditQuestion = () => {
    setEditingQuestion(null);
    setQuestionType(null);
    setQuestionForm({ title: '', options: ['', ''], reasons: ['', ''], correctAnswers: [] });
  };
console.log("gen",assessmentData)
  // Delete a question
  const handleDeleteQuestion = async (questionId) => {
    try {
      if (!adminData?.id) {
        throw new Error('Admin not authenticated. Please log in.');
      }

      const response = await fetch(`${API_URL}/api/v1/admin/assessments/${id}/questions/${questionId}`, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ creatorId: adminData.id }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to delete question');
      }

      setQuestions((prev) => prev.filter((q) => q._id !== questionId));
      setError(null);
    } catch (err) {
      setError(err.message);
    }
  };

  // Generate options for hours and minutes
  const hourOptions = Array.from({ length: 24 }, (_, i) => i);
  const minuteOptions = Array.from({ length: 60 }, (_, i) => i);

if (loading) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm bg-black/10">
      <svg
        className="animate-spin h-10 w-10 text-blue-600"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        />
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
        />
      </svg>
    </div>
  );
}



  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4 sm:px-6 lg:px-8">
      
      <div className="mx-auto">
        
        {/* Main Content */}
        <div className="bg-white rounded-xl shadow-lg p-6">
          {error && (
            <div className="mb-6 p-4 bg-red-100 text-red-700 rounded-lg">
              {error}
            </div>
          )}

      {/* Display Assessment URL if Published */}
        {assessmentData.status == 1 && assessmentData.slug && (
  <div className="mb-6 p-4 bg-blue-100 text-blue-700 rounded-lg">
    <p className="font-semibold">Assessment URL:</p>
    <div className="flex items-center space-x-2">
      <a
        href={`${window.location.origin}/assessments/${assessmentData.slug}`}
        target="_blank"
        rel="noopener noreferrer"
        className="text-blue-600 underline hover:text-blue-800"
      >
        {`${window.location.origin}/assessments/${assessmentData.slug}`}
      </a>
      <button
          onClick={handleCopyLink}
          className={`px-2 py-1 rounded focus:outline-none transition-colors duration-300 ${
            copied
              ? 'bg-green-600 text-white hover:bg-green-700'
              : 'bg-blue-600 text-white hover:bg-blue-700'
          }`}
        >
          {copied ? 'Copied!' : 'Copy Link'}
        </button>
    </div>
  </div>
)}

        {/* ... existing header, fields, and questions sections ... */}

        {/* Post/Draft Button */}
        {questions.length > 0 && (
          <button
            onClick={handleToggleStatus}
            className={`fixed bottom-6 right-6 px-6 py-3 ${
              assessmentData.status === 0 ? 'bg-green-600 hover:bg-green-700' : 'bg-red-600 hover:bg-red-700'
            } text-white rounded-full shadow-lg flex items-center gap-2 z-50`}
            disabled={isEditing || isAddingQuestion || editingQuestion}
          >
            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d={assessmentData.status === 0 ? 'M5 13l4 4L19 7' : 'M6 18L18 6M6 6l12 12'}
              />
            </svg>
            {assessmentData.status === 0 ? 'Post' : 'Draft'}
          </button>
        )}

          {/* Header with Title and Edit Button */}
        <div className="flex items-center justify-between mb-6">
          <h1 className="text-3xl font-bold text-gray-800 whitespace-pre-wrap">{assessmentData.title}</h1>
          {!isEditing ? (
            <button
              onClick={toggleEdit}
              className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center gap-2"
            >
              <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
                />
              </svg>
              Edit
            </button>
          ) : (
            <div className="flex gap-2">
              <button
                onClick={handleSave}
                className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
              >
                Save
              </button>
              <button
                onClick={toggleEdit}
                className="px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300"
              >
                Cancel
              </button>
            </div>
          )}
        </div>

         <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
  {/* Title */}
  <div>
    <label className="block text-gray-700 text-sm font-semibold mb-2">Title</label>
    {isEditing ? (
      <textarea
        name="title"
        value={formData.title}
        onChange={handleInputChange}
        className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-gray-50 text-gray-800 resize-y"
        placeholder="Enter assessment title"
        rows={3}
        required
      />
    ) : (
      <p className="text-gray-600 whitespace-pre-wrap">{assessmentData.title}</p>
    )}
  </div>

  {/* Duration */}
  <div>
    <label className="block text-gray-700 text-sm font-semibold mb-2">Duration</label>
    {isEditing ? (
      <div className="flex gap-4">
        <select
          name="hours"
          value={formData.hours}
          onChange={handleInputChange}
          className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-gray-50 text-gray-800"
          required
        >
          <option value="" disabled>
            Hours
          </option>
          {hourOptions.map((hour) => (
            <option key={hour} value={hour}>
              {hour}
            </option>
          ))}
        </select>
        <select
          name="minutes"
          value={formData.minutes}
          onChange={handleInputChange}
          className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-gray-50 text-gray-800"
          required
        >
          <option value="" disabled>
            Minutes
          </option>
          {minuteOptions.map((minute) => (
            <option key={minute} value={minute}>
              {minute}
            </option>
          ))}
        </select>
      </div>
    ) : (
      <p className="text-gray-600">{formatDuration(assessmentData.duration)}</p>
    )}
  </div>

  {/* Maximum Attempts */}
  <div>
    <label className="block text-gray-700 text-sm font-semibold mb-2">Maximum Attempts</label>
    {isEditing ? (
      <select
        name="maxTries"
        value={formData.maxTries}
        onChange={handleInputChange}
        className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-gray-50 text-gray-800"
        required
      >
        <option value="" disabled>Select maximum attempts</option>
        {Array.from({ length: 10 }, (_, i) => i + 1).map((num) => (
          <option key={num} value={num}>{num}</option>
        ))}
      </select>
    ) : (
      <p className="text-gray-600">{assessmentData.maxTries}</p>
    )}
  </div>

  {/* Conditionally Render AI-Specific Fields */}
  {assessmentData.isAiGenerated === 1 && (
    <>
      {/* Assessment Type */}
      <div>
        <label className="block text-gray-700 text-sm font-semibold mb-2">Assessment Type</label>
        {isEditing ? (
         <input
              type="text"
              id="assessmentType"
              name="assessmentType"
              value={formData.assessmentType}
              onChange={(e) => setFormData({ ...formData, assessmentType: e.target.value })}
              className="w-full px-4 py-3 border border-gray-200 rounded-lg bg-gray-100 text-gray-800"
            />
        ) : (
          <p className="text-gray-600">{assessmentData.assessmentType}</p>
        )}
      </div>

      {/* Number of Questions */}
      <div>
        <label className="block text-gray-700 text-sm font-semibold mb-2">Number of Questions</label>
        {isEditing ? (
          <input
            type="number"
            name="numberOfQuestions"
            value={formData.numberOfQuestions}
            onChange={handleInputChange}
            min="1"
            className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-gray-50 text-gray-800"
            placeholder="Enter number of questions"
            required
          />
        ) : (
          <p className="text-gray-600">{assessmentData.numberOfQuestions}</p>
        )}
      </div>

     <div>
          <label className="block text-gray-700 text-sm font-semibold mb-2">
            Difficulty Level
          </label>

          {isEditing ? (
            <select
              name="difficultyLevel"
              value={formData.difficultyLevel}
              onChange={(e) => handleDifficultyChange(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
            >
              <option value="">Select difficulty</option>
              {['Easy', 'Medium', 'Hard'].map((level) => (
                <option key={level} value={level}>
                  {level}
                </option>
              ))}
            </select>
          ) : (
            <p className="text-gray-600">{assessmentData.difficultyLevel || 'Not specified'}</p>
          )}
    </div>

    </>
  )}

  {/* Description */}
  <div className="md:col-span-2">
    <label className="block text-gray-700 text-sm font-semibold mb-2">Description</label>
    {isEditing ? (
      <div className="border border-gray-200 rounded-lg bg-gray-50">
        <CKEditor
          editor={ClassicEditor}
          data={formData.description}
          onReady={(editor) => {
            console.log('CKEditor initialized:', editor);
            if (editor) {
              editor.editing.view.change((writer) => {
                writer.setStyle(
                  'min-height',
                  '300px',
                  editor.editing.view.document.getRoot()
                );
              });
            }
          }}
          onChange={handleDescriptionChange}
          onError={(error) => {
            console.error('CKEditor error:', error);
            setError('Failed to load the editor. Please try again.');
          }}
          config={{
            toolbar: [
              'heading', '|',
              'bold', 'italic', 'underline', 'strikethrough', '|',
              'link', 'bulletedList', 'numberedList', 'blockQuote', '|',
              'insertTable', 'undo', 'redo',
            ],
            heading: {
              options: [
                { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
                { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
                { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
                { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' },
              ],
            },
            table: {
              contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells'],
            },
            link: {
              addTargetToExternalLinks: false,
              decorators: [],
            },
            placeholder: 'Enter a detailed description of the assessment...',
            removePlugins: ['Style', 'Font', 'Alignment', 'Image', 'ImageUpload', 'EasyImage', 'CKFinder'],
          }}
        />
      </div>
    ) : (
      <div
        className="text-gray-600"
        dangerouslySetInnerHTML={
          assessmentData.description
            ? renderHTML(assessmentData.description)
            : { __html: '<p>No description provided.</p>' }
        }
      />
    )}
  </div>

  {/* Instructions */}
  <div className="md:col-span-2">
    <label className="block text-gray-700 text-sm font-semibold mb-2">Instructions</label>
    {isEditing ? (
      <div className="border border-gray-200 rounded-lg bg-gray-50">
        <CKEditor
          editor={ClassicEditor}
          data={formData.instructions}
          onReady={(editor) => {
            console.log('CKEditor instructions initialized:', editor);
            if (editor) {
              editor.editing.view.change((writer) => {
                writer.setStyle('min-height', '300px', editor.editing.view.document.getRoot());
              });
            }
          }}
          onChange={handleInstructionsChange}
          onError={(error) => {
            console.error('CKEditor instructions error:', error);
            setError('Failed to load the instructions editor. Please try again.');
          }}
          config={{
            toolbar: [
              'heading', '|',
              'bold', 'italic', 'underline', 'strikethrough', '|',
              'link', 'bulletedList', 'numberedList', 'blockQuote', '|',
              'insertTable', 'undo', 'redo',
            ],
            heading: {
              options: [
                { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
                { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
                { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
                { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' },
              ],
            },
            table: {
              contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells'],
            },
            link: {
              addTargetToExternalLinks: false,
              decorators: [],
            },
            placeholder: 'Enter detailed instructions for the assessment...',
            removePlugins: ['Style', 'Font', 'Alignment', 'Image', 'ImageUpload', 'EasyImage', 'CKFinder'],
          }}
        />
      </div>
    ) : (
      <div
        className="text-gray-600"
        dangerouslySetInnerHTML={
          assessmentData.instructions
            ? renderHTML(assessmentData.instructions)
            : { __html: '<p>No instructions provided.</p>' }
        }
      />
    )}
  </div>

  {/* Job Description (AI-Specific) */}
  {assessmentData.isAiGenerated === 1 && (
    <div className="md:col-span-2">
      <label className="block text-gray-700 text-sm font-semibold mb-2">Job Description</label>
      {isEditing ? (
        <div className="border border-gray-200 rounded-lg bg-gray-50">
          <CKEditor
            editor={ClassicEditor}
            data={formData.jobDescription}
            onReady={(editor) => {
              console.log('CKEditor job description initialized:', editor);
              if (editor) {
                editor.editing.view.change((writer) => {
                  writer.setStyle(
                    'min-height',
                    '300px',
                    editor.editing.view.document.getRoot()
                  );
                });
              }
            }}
            onChange={handleJobDescriptionChange}
            onError={(error) => {
              console.error('CKEditor job description error:', error);
              setError('Failed to load the job description editor. Please try again.');
            }}
            config={{
              toolbar: [
                'heading', '|',
                'bold', 'italic', 'underline', 'strikethrough', '|',
                'link', 'bulletedList', 'numberedList', 'blockQuote', '|',
                'insertTable', 'undo', 'redo',
              ],
              heading: {
                options: [
                  { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
                  { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
                  { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
                  { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' },
                ],
              },
              table: {
                contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells'],
              },
              link: {
                addTargetToExternalLinks: false,
                decorators: [],
              },
              placeholder: 'Enter the job description...',
              removePlugins: ['Style', 'Font', 'Alignment', 'Image', 'ImageUpload', 'EasyImage', 'CKFinder'],
            }}
          />
        </div>
      ) : (
        <div
          className="text-gray-600"
          dangerouslySetInnerHTML={
            assessmentData.jobDescription
              ? renderHTML(assessmentData.jobDescription)
              : { __html: '<p>No job description provided.</p>' }
          }
        />
      )}
    </div>
   )} 
</div>
  

         {/* Update Add Question and Mode Toggle Section */}
        <div className="flex justify-between items-center mb-8">
          <div className="flex items-center gap-4">
            <label className="text-gray-700 text-sm font-semibold">Assessment Mode</label>
            <div className="flex bg-gray-100 rounded-full p-1 shadow-sm">
              <button
                type="button"
                onClick={() => handleToggleMode('check')}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-colors duration-200 flex items-center gap-2 ${
                  assessmentMode === 0
                    ? 'bg-green-600 text-white shadow'
                    : 'bg-transparent text-gray-600 hover:bg-gray-200'
                }`}
              >
                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                Check Ans
              </button>
              <button
                type="button"
                onClick={() => handleToggleMode('test')}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-colors duration-200 flex items-center gap-2 ${
                  assessmentMode === 1
                    ? 'bg-red-600 text-white shadow'
                    : 'bg-transparent text-gray-600 hover:bg-gray-200'
                }`}
              >
                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                Test
              </button>
            </div>
          </div>
          <div className="flex bg-gray-100 rounded-full p-1 shadow-sm" style={{width:"fit-content"}}>
            <button
              type="button"
              onClick={() => handleToggleResult('no')}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-colors duration-200 flex items-center gap-2 ${
                resultMode === 0
                  ? 'bg-gray-600 text-white shadow'
                  : 'bg-transparent text-gray-600 hover:bg-gray-200'
              }`}
            >
              <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
              No Result
            </button>
            <button
              type="button"
              onClick={() => handleToggleResult('show')}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-colors duration-200 flex items-center gap-2 ${
                resultMode === 1
                  ? 'bg-blue-600 text-white shadow'
                  : 'bg-transparent text-gray-600 hover:bg-gray-200'
              }`}
            >
              <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              Show Result
            </button>
          </div>
          <div className='flex gap-11'>
            {assessmentData.isAiGenerated === 1 && (
                <button
                  onClick={() => handleAddAIQuestion(id, formData)}
                  className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center gap-2 highlight_bg"
                  type="button"
                >
                  <img src={star} className="w-4 mr-1" alt="AI" />
                  Generate Question
                </button>

              )}
              {!isAddingQuestion && (
                <button
                  onClick={() => {
                    setIsAddingQuestion(true);
                    setQuestionType(null);
                    setQuestionForm({ title: '', options: ['', ''], reasons: ['', ''], correctAnswers: [] });
                    setEditingQuestion(null);
                  }}
                  className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center gap-2"
                >
                  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                  </svg>
                  Add Question
                </button>
              )}
              
          </div>
        </div>
        

          {/* Questions Section */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Questions</h2>
            
            {/* Add Question Input Box */}
            {isAddingQuestion && !editingQuestion && (
              <div className="bg-gray-50 p-4 rounded-lg shadow mb-4 border border-blue-200">
                <h3 className="text-lg font-medium text-gray-800 mb-4">Add New Question</h3>
                
                {/* Question Type */}
                <div className="mb-4">
                  <label className="block text-gray-700 text-sm font-semibold mb-2">Question Type</label>
                  <select
                    value={questionType || ''}
                    onChange={handleQuestionTypeSelect}
                    className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-gray-50 text-gray-800"
                    required
                  >
                    <option value="" disabled>Select type</option>
                    <option value="single">Single Answer</option>
                    <option value="multiple">Multiple Answer</option>
                  </select>
                </div>

                {questionType && (
                  <>
                    {/* Question Title */}
                    <div className="mb-4">
                      <label className="block text-gray-700 text-sm font-semibold mb-2">Question Title</label>
                      <textarea
                        name="title"
                        value={questionForm.title}
                        onChange={handleQuestionInputChange}
                        className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-gray-50 text-gray-800"
                        placeholder="Enter question title"
                        required
                      />
                    </div>

                    {/* Options */}
                    <div className="mb-4">
                      <label className="block text-gray-700 text-sm font-semibold mb-2">Options</label>
                      {questionForm.options.map((option, index) => (
                        <div key={index} className="mb-4">
                          <div className="flex items-center gap-2 mb-2">
                            <input
                              type="text"
                              name={`option-${index}`}
                              value={option}
                              onChange={(e) => handleQuestionInputChange(e, index)}
                              className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-gray-50 text-gray-800"
                              placeholder={`Option ${index + 1}`}
                              required
                            />
                            {questionType === 'single' ? (
                              <input
                                type="radio"
                                name="correctAnswer"
                                value={index}
                                checked={questionForm.correctAnswers.includes(index)}
                                onChange={(e) => handleCorrectAnswerChange(e, index)}
                                className="h-5 w-5 text-blue-600"
                              />
                            ) : (
                              <input
                                type="checkbox"
                                name="correctAnswer"
                                value={index}
                                checked={questionForm.correctAnswers.includes(index)}
                                onChange={(e) => handleCorrectAnswerChange(e, index)}
                                className="h-5 w-5 text-blue-600"
                              />
                            )}
                            <button
                              onClick={() => deleteOption(index)}
                              className={`p-2 rounded-full ${
                                questionForm.options.length <= 2
                                  ? 'text-gray-400 cursor-not-allowed'
                                  : 'text-red-600 hover:bg-red-100'
                              }`}
                              disabled={questionForm.options.length <= 2}
                            >
                              <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={2}
                                  d="M6 18L18 6M6 6l12 12"
                                />
                              </svg>
                            </button>
                          </div>
                          <input type="text"
                            name={`reason-${index}`}
                            value={questionForm.reasons[index] || ''}
                            onChange={(e) => handleQuestionInputChange(e, index)}
                            className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-gray-50 text-gray-800"
                            placeholder={`Reason for option ${index + 1} (optional)`}
                            rows={3}
                          />
                        </div>
                      ))}
                      <button
                        onClick={addOption}
                        className="mt-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center gap-2"
                      >
                        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                        </svg>
                        Add Option
                      </button>
                    </div>

                    {/* Buttons */}
                    <div className="flex justify-end gap-2">
                      <button
                        onClick={handleQuestionSubmit}
                        className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
                        disabled={!questionType}
                      >
                        Save
                      </button>
                      <button
                        onClick={() => {
                          setIsAddingQuestion(false);
                          setQuestionType(null);
                          setQuestionForm({ title: '', options: ['', ''], reasons: ['', ''], correctAnswers: [] });
                        }}
                        className="px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300"
                      >
                        Cancel
                      </button>
                    </div>
                  </>
                )}
              </div>
            )}

            {/* Questions List */}
            {questions.length === 0 && !isAddingQuestion ? (
              <p className="text-gray-600 text-center">No questions added yet.</p>
            ) : (
              <div className="space-y-4">
                {questions.map((question, index) => (
  <div
    key={question._id || index}
    className={`bg-gray-50 p-4 rounded-lg shadow ${editingQuestion?._id === question._id ? 'border border-blue-200' : ''}`}
  >
    {editingQuestion?._id === question._id ? (
      <>
        {/* Question Type */}
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-semibold mb-2">Question Type</label>
          <select
            value={questionType || ''}
            onChange={handleQuestionTypeSelect}
            className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-gray-50 text-gray-800"
            required
          >
            <option value="" disabled>Select type</option>
            <option value="single">Single Answer</option>
            <option value="multiple">Multiple Answer</option>
          </select>
        </div>

        {questionType && (
          <>
            {/* Question Title */}
            <div className="mb-4">
              <label className="block text-gray-700 text-sm font-semibold mb-2">Question Title</label>
              <textarea
                name="title"
                value={questionForm.title}
                onChange={handleQuestionInputChange}
                className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-gray-50 text-gray-800"
                placeholder="Enter question title"
                required
                rows={4} // Optional: Increase rows for better visibility
              />
            </div>

            {/* Options */}
            <div className="mb-4">
              <label className="block text-gray-700 text-sm font-semibold mb-2">Options</label>
              {questionForm.options.map((option, optIndex) => (
                <div key={optIndex} className="mb-4">
                  <div className="flex items-center gap-2 mb-2">
                    <input
                      type="text"
                      name={`option-${optIndex}`}
                      value={option}
                      onChange={(e) => handleQuestionInputChange(e, optIndex)}
                      className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-gray-50 text-gray-800"
                      placeholder={`Option ${optIndex + 1}`}
                      required
                    />
                    {questionType === 'single' ? (
                      <input
                        type="radio"
                        name="correctAnswer"
                        value={optIndex}
                        checked={questionForm.correctAnswers.includes(optIndex)}
                        onChange={(e) => handleCorrectAnswerChange(e, optIndex)}
                        className="h-5 w-5 text-blue-600"
                      />
                    ) : (
                      <input
                        type="checkbox"
                        name="correctAnswer"
                        value={optIndex}
                        checked={questionForm.correctAnswers.includes(optIndex)}
                        onChange={(e) => handleCorrectAnswerChange(e, optIndex)}
                        className="h-5 w-5 text-blue-600"
                      />
                    )}
                    <button
                      onClick={() => deleteOption(optIndex)}
                      className={`p-2 rounded-full ${
                        questionForm.options.length <= 2
                          ? 'text-gray-400 cursor-not-allowed'
                          : 'text-red-600 hover:bg-red-100'
                      }`}
                      disabled={questionForm.options.length <= 2}
                    >
                      <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M6 18L18 6M6 6l12 12"
                        />
                      </svg>
                    </button>
                  </div>
                  <input
                    type="text"
                    name={`reason-${optIndex}`}
                    value={questionForm.reasons[optIndex] || ''}
                    onChange={(e) => handleQuestionInputChange(e, optIndex)}
                    className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-gray-50 text-gray-800"
                    placeholder={`Reason for option ${optIndex + 1} (optional)`}
                    rows={3}
                  />
                </div>
              ))}
              <button
                onClick={addOption}
                className="mt-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center gap-2"
              >
                <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                </svg>
                Add Option
              </button>
            </div>

            {/* Buttons */}
            <div className="flex justify-end gap-2">
              <button
                onClick={handleQuestionSubmit}
                className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
                disabled={!questionType}
              >
                Update
              </button>
              <button
                onClick={cancelEditQuestion}
                className="px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300"
              >
                Cancel
              </button>
            </div>
          </>
        )}
      </>
    ) : (
      <>
        <div className="flex justify-between items-start">
          <h3 className="flex items-start gap-1 text-lg font-medium text-gray-800">
            <span>{index + 1}.</span>
            <span
              className="whitespace-pre-wrap"
              style={{ display: 'inline-block' }}
            >
              {question.questionText}
            </span>
            <span className="ml-1 text-sm text-gray-500">
              ({question.type === 'single' ? 'Single Answer' : 'Multiple Answer'})
            </span>
          </h3>
          <div className="flex gap-2">
            <button
              onClick={() => openEditQuestion(question)}
              className="text-blue-600 hover:text-blue-800"
            >
              <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
                />
              </svg>
            </button>
            <button
              onClick={() => handleDeleteQuestion(question._id)}
              className="text-red-600 hover:text-red-800"
            >
              <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
        </div>
        <ul className="mt-2 space-y-1">
          {question.options.map((option, optIndex) => (
            <li key={optIndex} className="space-y-1">
              <div className="flex items-center gap-2">
                <span>
                  {optIndex + 1}. {option}
                </span>
                {(question.correctAnswers || []).includes(optIndex) && (
                  <span className="text-green-600 font-medium">(Correct)</span>
                )}
              </div>
              {question.reasons && question.reasons[optIndex] && (
                <p className="text-sm text-gray-500 ml-6">
                  <span className="font-semibold">Reason:</span> {question.reasons[optIndex]}
                </p>
              )}
            </li>
          ))}
        </ul>
      </>
    )}
  </div>
))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssessmentDetailsPage;